import { Col, Progress, Row } from "reactstrap";

const progressBarStyles = {
  height: "5px",
};

const progressTextStyles = {
  fontSize: "12px",
  fontWeight: "600",
  textTransform: "uppercase",
};

function ProgressBar(props) {
  const { showProgressBar, totalSections, maxSectionCompleted } = props;
  if (!showProgressBar) {
    return null;
  }

  return (
    <Row className="g-0 mb-4">
      <Col xs="6" className="text-start" style={progressTextStyles}>
        Your Progress
      </Col>
      <Col xs="6" className="text-end" style={progressTextStyles}>
        {Math.floor((maxSectionCompleted / totalSections) * 100)}%
      </Col>
      <Col xs="12">
        <Progress
          style={progressBarStyles}
          max={totalSections}
          value={maxSectionCompleted}
        />
      </Col>
    </Row>
  );
}

export default ProgressBar;
